import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/views/Home'
import ConfirmReservation from '../components/views/ConfirmReservation'
import Login from '../components/views/Login'
import Admin from '../components/views/Admin'
import Booking from '../components/admin/Booking'
import Settings from '../components/admin/Settings'
import Reservations from '../components/admin/Reservations'
import Boats from '../components/admin/Boats'
import Users from '../components/admin/Users'
import Reasons from '../components/admin/Reasons'
import Services from '../components/admin/Services'
import Vouchers from '../components/admin/Vouchers'
import app from '../services/index'
import store from '../store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: Home,
    },
    {
      name: 'confirmReservation',
      path: '/reservation/:id/confirm',
      component: ConfirmReservation
    },
    {
      path: '/admin',
      component: Admin,
      children: [
        {
          path: '',
          component: Booking
        },
        {
          path: 'booking',
          component: Booking
        },
        {
          path: 'boats',
          component: Boats
        },
        {
          path: 'users',
          component: Users
        },
        {
          path: 'reasons',
          component: Reasons
        },
        {
          path: 'vouchers',
          component: Vouchers
        },
        {
          path: 'services',
          component: Services
        },
        {
          path: 'settings',
          component: Settings
        },
        {
          path: 'reservations',
          component: Reservations
        },
      ]
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/logout',
      beforeEnter: function (to, from, next) {
        app.logout().then(function () {
          store.dispatch('logoutUser')
          next('/login')
        });
      }.bind(this)
    },
  ]
})

router.beforeEach((to, from, next) => {

  if (store.state.user.authenticated || to.path === '/login' || to.path === '/' || to.name === 'confirmReservation') {
    next()
    return
  }

  app.authenticate({
  }).then(function() {
    store.dispatch('authenticateUser', app.get('user')).then(() => {
      next()
    })
  }).catch(function (error) {
    console.error(error)
    next('/login')
  }.bind(this))
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js